const handleResponseErrors = (response, body) => {
  if (!response.ok) {
    // console.log('error=', body.errors[0])
    throw Error(body.errors[0])
  }
  return response
}

/**
 * Posts data to an endpoint
 */
async function postData(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(data)
  })
  return response.json()
}

async function putData(url = '', data = {}) {
  // Default options are marked with *
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify(data)
  })
  return response.json()
}

async function deleteData(url = '') {
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  })
  return response.json()
}

async function fetchWithTimeout(resource, options = {}) {
  // fetch() times out at 300 seconds in Chrome, 90 seconds in Firefox
  // set this to the higher of those so this has no effect in the base case
  const { timeout = 300000 } = options  // try 5000

  const controller = new AbortController()
  const id = setTimeout(() => controller.abort(), timeout)

  const response = await fetch(resource, {
    ...options,
    signal: controller.signal
  })
  clearTimeout(id)

  return response
}

export { deleteData, fetchWithTimeout, handleResponseErrors, postData, putData }
